// src/components/button/BtnRefresh.tsx

import { RefreshTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

type Props = {
  onClick: () => void
}

export const BtnRefresh = ({ onClick }: Props) => (
  <Tooltip arrow placement={'top'} title={'Neu fetchen'}>
    <IconButton onClick={onClick} sx={{ bgcolor: '#DDD' }}>
      <RefreshTwoTone />
    </IconButton>
  </Tooltip>
)
